import React from 'react';
import { projects } from '../data/projects';

const Projects: React.FC = () => {
  return (
    <section id="projects" className="py-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl sm:text-4xl font-bold mb-4 text-ink-900">
            Recent Projects
          </h2>
          <p className="text-lg text-ink-500 max-w-2xl mx-auto">
            Showcasing our latest work and achievements
          </p>
        </div>
        
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-8">
          {projects.map((project) => (
            <div key={project.id} className="glass-card p-8">
              <h3 className="text-xl font-semibold mb-4 text-ink-900">
                {project.title}
              </h3>
              <p className="text-ink-500 mb-6 leading-relaxed">
                {project.outcome}
              </p>
              <div className="flex flex-wrap gap-2">
                {project.technologies.map((tech, index) => (
                  <span key={index} className="tag">
                    {tech}
                  </span>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Projects; 